import { Component, OnInit } from '@angular/core';
import { DataGridTemplate } from '../../../../../shared/data-grid/data-grid.template';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FormDialogTemplate } from '../../../../../shared/form-dialog/form-dialog.template';
import { CtwrPartTypeService } from '../../../ctwr.service';

@Component({
  selector: 'app-part-types',
  templateUrl: './part-types.component.html',
  styleUrls: ['./part-types.component.scss']
})
export class PartTypesComponent extends DataGridTemplate implements OnInit {

  editForm: FormGroup;
  formDialog: FormDialogTemplate;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly partTypeService: CtwrPartTypeService,
  ) {
    super();
    this.controls.edit = false;
  }

  ngOnInit() {
    this.formDialog = new FormDialogTemplate();
    this.modal = true;
    this.sortable = true;
    this.filterable = 'menu';
    this.gridState.sort = [{ dir: 'asc', field: 'Name' }];

    this.editForm = this.formBuilder.group({
      Id: [],
      Name: ['', Validators.compose([Validators.required, Validators.maxLength(65)])],
    })
    this.formDialog.notificationLabel = { flag: 'info', state: 'edit', value: '*Editing this record may impact current, future, and past requests.' };

    this.formDialog.initilize("Part Type", this.editForm, this.formDialogTabs);
  }


  read(opts: any): Promise<any> {
    return opts.force ?
      this.partTypeService.read('') :
      Promise.resolve(this.partTypeService.value);
  }


  create(parentEditDataItem: any): void {
    this.formDialog.isNew = true;
    this.formDialog.next(this.editDataItem);
  }


  edit(dataItem: any): void {
    this.formDialog.isNew = false;
    this.partTypeService.read(`/${dataItem.Id}`)
      .then(x => {
        this.formDialog.next(x);
      })
  }


  save(dataItem: any, isNew: boolean): Promise<any> {
    const _path = isNew ? '' : `?id=${dataItem.Id}`;
    return this.partTypeService.save(dataItem, isNew, _path, false);
  }


  delete(dataItem: any): Promise<any> {
    return this.partTypeService.remove(`/${dataItem.Id}`, false);
  }


  columns: any[] = [
    {
      field: 'Name',
      title: 'Name',
    },
  ]


  formControls = [
    {
      type: 'text',
      title: 'Name',
      name: 'Name',
      invalidText: 'Invalid Name. Name must be between 1 and 65 characters.'
    },
  ]


  formDialogTabs = [
    {
      title: "Part Type",
      selected: true,
      formControls: this.formControls
    },
  ]
}

